import './Cards.less';

const CardElement = ({ element, className, children, ...props }) => {
    return (
        <div className={`${element} ${className ? className : ''}`} {...props}>
            {children}
        </div>
    );
};

const Cards = (props) => (
    <div className='Cards-container'>
        <CardElement element="Cards" {...props} />
    </div>
);
const Card = (props) => <CardElement element="Card" {...props} />;
const CardMedia = (props) => <CardElement element="CardMedia" {...props} />;
const CardHeader = (props) => <CardElement element="CardHeader" {...props} />;
const CardMain = (props) => <CardElement element="CardMain" {...props} />;
const CardFooter = (props) => <CardElement element="CardFooter" {...props} />;

export {
    Cards,
    Card,
    CardMedia,
    CardHeader,
    CardMain,
    CardFooter,
};
